<bdo-text-box-page
  [title]="title"
  [boxTitle]="'noService.processNotAvailable.title' | translate"
  [infoText]="'noService.processNotAvailable.description' | translate: { link: link }"
  [linkData]="linkData"
></bdo-text-box-page>
